<template>
  <basic-container>
    <avue-crud :option="option" v-model:search="search" v-model="form" :data="data" :before-open="beforeOpen" ref="crud"
      @row-update="rowUpdate" @row-save="rowSave" @row-del="rowDel" @on-load="onLoad">
      <template slot-scope="scope" slot="menuLeft">
        <el-button type="primary" size="small" icon="el-icon-upload2" plain @click="handleImport">导入
        </el-button>
      </template>
    </avue-crud>

    <el-dialog width="400px" :visible.sync="isImportDialogShow" :append-to-body="true" :close-on-click-modal="false">
      <ImportFile v-if="isImportDialogShow" title="导入数据"
        exportApi="/api/nursing/template/exportTemplate" importApi="/api/nursing/template/importTemplate" :importParams="{id:row.id}"
        @uploadCallBack="importCallBack"></ImportFile>
    </el-dialog>
  </basic-container>
</template>

<script>
import { getList, getDetail, add, update, remove } from '../api/nursingManage.js';
import ImportFile from '@/views/nursingHome/initData/importFile';
export default {
  props: {
    row: {
      default: {},
    }
  },
  components: {
    ImportFile,
  },
  data() {
    return {
      form: {},
      loading: true,
      isImportDialogShow: false,
      option: {
        height: 'auto',
        calcHeight: 30,
        tip: false,
        delBtn: true,
        addBtn: true,
        editBtn: true,
        refreshBtn: false,
        columnBtn: false,
        index: true,
        border: true,
        dialogClickModal: false,
        column: [
          {
            label: '日常活动',
            prop: 'dailyActivities',
            maxlength: 200,
            showWordLimit: true,
            rules: [
              {
                required: true,
                message: '请输入日常活动',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '最高分值',
            prop: 'maxScore',
            rules: [
              {
                required: true,
                message: '请输入最高分值',
                trigger: 'blur'
              },
              {
                pattern: /^[1-9]\d{0,8}$/,
                message: '请输入正整数',
                trigger: 'blur',
              },
            ],
            maxlength: 9,
            showWordLimit: true,
            value: 10,
          },
          {
            label: '评估标准',
            prop: 'evaluateType',
            span: 24,
            type: 'textarea',
            minRows: 2,
            maxlength: 500,
            showWordLimit: true,
            rules: [
              {
                required: true,
                message: '请输入评估标准',
                trigger: 'blur',
              },
            ],
          },
        ]
      },
      data: []
    };
  },
  methods: {
    rowSave(row, done, loading) {
      add({
        nursinghomeId: this.row.id,
        ...row
      }).then(() => {
        // this.$emit('success');
        this.onLoad();
        this.$message({
          type: "success",
          message: "操作成功!"
        });
        done();
      }, error => {
        loading();
        window.console.log(error);
      });
    },
    rowUpdate(row, index, done, loading) {
      update({
        nursinghomeId: this.row.id,
        ...row
      }).then(() => {
        this.onLoad();
        this.$message({
          type: "success",
          message: "操作成功!"
        });
        done();
      }, error => {
        loading();
        console.log(error);
      });
    },
    rowDel(row) {
      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          return remove(row.id);
        })
        .then(() => {
          this.onLoad();
          this.$message({
            type: "success",
            message: "操作成功!"
          });
        });
    },
    handleImport() {
      this.isImportDialogShow = true
    },
    beforeOpen(done, type) {
      if (["edit"].includes(type)) {
        getDetail(this.form.id).then(res => {
          this.form = res.data;
        });
      }
      done();
    },

    /* 导入成功的回调 */
    importCallBack(ret) {
      if (ret) {
        this.isImportDialogShow = false;
        this.onLoad();
      }
    },
    onLoad() {
      console.log(this.row, 'row');
      this.loading = true;
      getList(
        {
          nursinghomeId: this.row.id,
        }
      ).then(res => {
        this.data = res.data;
        this.loading = false;
      });
    }
  }
};
</script>

<style></style>
